import { setAndroidApplicationLocales } from "../../modules/android-app-locales";

import {
    SYSTEM_LANGUAGE,
    type AppLanguage,
    isAppLanguage,
} from "./i18n";

/**
 * Syncs the in-app language preference to Android's per-app locales API
 * so native UI (e.g. date picker) matches Settings → Display language.
 */
export function syncAndroidApplicationLocales(preference: AppLanguage): void {
    if (preference === SYSTEM_LANGUAGE) {
        setAndroidApplicationLocales(null);
        return;
    }

    if (isAppLanguage(preference)) {
        setAndroidApplicationLocales(preference);
    }
}
